module.exports = __webpack_public_path__ + "img/13800.380d1a85.jpg";